import { connect } from 'react-redux';
import * as moment from 'moment';
import BaseForm from '../BaseForm/BaseForm';
import {
  updateHoliday,
  showError,
  clearErrors,
} from '../../redux/actions/holidays';
import conditions from '../../data/conditions';

class HolidayUpdateForm extends BaseForm {
  constructor(props) {
    super(props, {
      onSubmit: updateHoliday,
      name: 'Holiday',
      action: 'Update',
      type: 'update',
      isTypeForm: false,
    });
  }

  /**
   * Handle form validation
   */
  handleValidate(
    data,
    isIndex: (index: number) => boolean = () => {
      return true;
    },
  ) {
    if (this.props.model.didInvalidate) {
      this.props.dispatch(clearErrors());
    }
    if (isIndex(0) && BaseForm.validator.isEmpty(data.name)) {
      this.props.dispatch(showError('Please specify a name'));
      return false;
    }
    if (isIndex(1) && BaseForm.validator.isEmpty(data.start_date)) {
      this.props.dispatch(showError('Please specify a start date'));
      return false;
    }
    if (isIndex(2) && BaseForm.validator.isEmpty(data.end_date)) {
      this.props.dispatch(showError('Please specify an end date'));
      return false;
    }
    const start = moment(`${data.start_date} 00:00:00`);
    if (!start.isValid()) {
      this.props.dispatch(showError(`The start date is not in a valid format`));
      return false;
    }
    const end = moment(`${data.end_date} 23:59:59`);
    if (!end.isValid()) {
      this.props.dispatch(showError(`The end date is not in a valid format`));
      return false;
    }
    if (!end.isSameOrAfter(start)) {
      this.props.dispatch(
        showError("Make sure the holiday's end is after the start"),
      );
      return false;
    }
    return {
      name: data.name,
      start: start.format('YYYY-MM-DD HH:mm:ss'),
      end: end.format('YYYY-MM-DD HH:mm:ss'),
      description: data.description,
    };
  }

  /**
   * Handle form reset
   */
  handleReset(dispatch, actions) {
    let { start, end } = this.props.item;
    start = moment(start).format('YYYY-MM-DD HH:mm:ss');
    end = moment(end).format('YYYY-MM-DD HH:mm:ss');
    dispatch(actions.change('update.name', this.props.item.name || ''));
    dispatch(actions.change('update.start_date', start.substring(0, 10) || ''));
    dispatch(actions.change('update.end_date', end.substring(0, 10) || ''));
    dispatch(
      actions.change('update.description', this.props.item.description || ''),
    );
  }
}

const mapStateToProps = ({ holidays }) => ({
  model: holidays,
  fields: BaseForm.fields.holidays.update,
});

export default connect(mapStateToProps)(HolidayUpdateForm);
